"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = divide;

var _channel = require("../../util/channel");

var _value = require("../../util/value");

/**
 * @memberof Image
 * @instance
 * @param {*} value
 * @param {object} [options]
 * @return {this}
 */
function divide(value, options = {}) {
  let {
    channels
  } = options;
  this.checkProcessable('divide', {
    bitDepth: [8, 16]
  });
  channels = (0, _channel.validateArrayOfChannels)(this, {
    channels: channels
  });
  value = (0, _value.checkNumberArray)(value);

  if (!isNaN(value)) {
    for (let j = 0; j < channels.length; j++) {
      let c = channels[j];

      for (let i = 0; i < this.data.length; i += this.channels) {
        this.data[i + c] = Math.min(this.maxValue, this.data[i + c] / value >> 0);
      }
    }
  } else {
    if (this.data.length !== value.length) {
      throw new Error('divide: the: the data size is different');
    }

    for (let j = 0; j < channels.length; j++) {
      let c = channels[j];

      for (let i = 0; i < this.data.length; i += this.channels) {
        this.data[i + c] = Math.max(0, Math.min(this.maxValue, this.data[i + c] / value[i + c] >> 0));
      }
    }
  }

  return this;
}